"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Head", {
  enumerable: true,
  get: function get() {
    return _reactHelmet.Helmet;
  }
});
Object.defineProperty(exports, "Root", {
  enumerable: true,
  get: function get() {
    return _Root["default"];
  }
});
Object.defineProperty(exports, "Routes", {
  enumerable: true,
  get: function get() {
    return _Routes["default"];
  }
});
Object.defineProperty(exports, "useRouteData", {
  enumerable: true,
  get: function get() {
    return _useRouteData["default"];
  }
});
Object.defineProperty(exports, "useSiteData", {
  enumerable: true,
  get: function get() {
    return _useSiteData["default"];
  }
});
Object.defineProperty(exports, "usePrefetch", {
  enumerable: true,
  get: function get() {
    return _usePrefetch["default"];
  }
});
Object.defineProperty(exports, "useLocation", {
  enumerable: true,
  get: function get() {
    return _useLocation["default"];
  }
});
Object.defineProperty(exports, "useBasepath", {
  enumerable: true,
  get: function get() {
    return _useBasepath["default"];
  }
});
Object.defineProperty(exports, "useStaticInfo", {
  enumerable: true,
  get: function get() {
    return _useStaticInfo.useStaticInfo;
  }
});
Object.defineProperty(exports, "useRoutePath", {
  enumerable: true,
  get: function get() {
    return _useRoutePath.useRoutePath;
  }
});
Object.defineProperty(exports, "routePathContext", {
  enumerable: true,
  get: function get() {
    return _useRoutePath.routePathContext;
  }
});
Object.defineProperty(exports, "RouteData", {
  enumerable: true,
  get: function get() {
    return _RouteData.RouteData;
  }
});
Object.defineProperty(exports, "withRouteData", {
  enumerable: true,
  get: function get() {
    return _RouteData.withRouteData;
  }
});
Object.defineProperty(exports, "SiteData", {
  enumerable: true,
  get: function get() {
    return _SiteData.SiteData;
  }
});
Object.defineProperty(exports, "withSiteData", {
  enumerable: true,
  get: function get() {
    return _SiteData.withSiteData;
  }
});
Object.defineProperty(exports, "addPrefetchExcludes", {
  enumerable: true,
  get: function get() {
    return _browser.addPrefetchExcludes;
  }
});
Object.defineProperty(exports, "getRouteInfo", {
  enumerable: true,
  get: function get() {
    return _browser.getRouteInfo;
  }
});
Object.defineProperty(exports, "isPrefetchableRoute", {
  enumerable: true,
  get: function get() {
    return _browser.isPrefetchableRoute;
  }
});
Object.defineProperty(exports, "onReloadClientData", {
  enumerable: true,
  get: function get() {
    return _browser.onReloadClientData;
  }
});
Object.defineProperty(exports, "onReloadTemplates", {
  enumerable: true,
  get: function get() {
    return _browser.onReloadTemplates;
  }
});
Object.defineProperty(exports, "pluginHooks", {
  enumerable: true,
  get: function get() {
    return _browser.pluginHooks;
  }
});
Object.defineProperty(exports, "plugins", {
  enumerable: true,
  get: function get() {
    return _browser.plugins;
  }
});
Object.defineProperty(exports, "prefetch", {
  enumerable: true,
  get: function get() {
    return _browser.prefetch;
  }
});
Object.defineProperty(exports, "prefetchData", {
  enumerable: true,
  get: function get() {
    return _browser.prefetchData;
  }
});
Object.defineProperty(exports, "prefetchTemplate", {
  enumerable: true,
  get: function get() {
    return _browser.prefetchTemplate;
  }
});
Object.defineProperty(exports, "registerPlugins", {
  enumerable: true,
  get: function get() {
    return _browser.registerPlugins;
  }
});
Object.defineProperty(exports, "registerTemplateForPath", {
  enumerable: true,
  get: function get() {
    return _browser.registerTemplateForPath;
  }
});
Object.defineProperty(exports, "registerTemplates", {
  enumerable: true,
  get: function get() {
    return _browser.registerTemplates;
  }
});
Object.defineProperty(exports, "routeErrorByPath", {
  enumerable: true,
  get: function get() {
    return _browser.routeErrorByPath;
  }
});
Object.defineProperty(exports, "routeInfoByPath", {
  enumerable: true,
  get: function get() {
    return _browser.routeInfoByPath;
  }
});
Object.defineProperty(exports, "sharedDataByHash", {
  enumerable: true,
  get: function get() {
    return _browser.sharedDataByHash;
  }
});
Object.defineProperty(exports, "templateErrorByPath", {
  enumerable: true,
  get: function get() {
    return _browser.templateErrorByPath;
  }
});
Object.defineProperty(exports, "templates", {
  enumerable: true,
  get: function get() {
    return _browser.templates;
  }
});
Object.defineProperty(exports, "templatesByPath", {
  enumerable: true,
  get: function get() {
    return _browser.templatesByPath;
  }
});
Object.defineProperty(exports, "getRoutePath", {
  enumerable: true,
  get: function get() {
    return _utils.getRoutePath;
  }
});
Object.defineProperty(exports, "makePathAbsolute", {
  enumerable: true,
  get: function get() {
    return _utils.makePathAbsolute;
  }
});
Object.defineProperty(exports, "pathJoin", {
  enumerable: true,
  get: function get() {
    return _utils.pathJoin;
  }
});
var _reactHelmet = require("react-helmet");
var _Root = _interopRequireDefault(require("./browser/components/Root"));
var _Routes = _interopRequireDefault(require("./browser/components/Routes"));
var _useRouteData = _interopRequireDefault(require("./browser/hooks/useRouteData"));
var _useSiteData = _interopRequireDefault(require("./browser/hooks/useSiteData"));
var _usePrefetch = _interopRequireDefault(require("./browser/hooks/usePrefetch"));
var _useLocation = _interopRequireDefault(require("./browser/hooks/useLocation"));
var _useBasepath = _interopRequireDefault(require("./browser/hooks/useBasepath"));
var _useStaticInfo = require("./browser/hooks/useStaticInfo");
var _useRoutePath = require("./browser/hooks/useRoutePath");
var _RouteData = require("./browser/components/RouteData");
var _SiteData = require("./browser/components/SiteData");
var _browser = require("./browser");
var _utils = require("./browser/utils");